import {
  BaseEntityDTO,
  RubricDTO,
  IBaseEntityDTO,
  IRubricDTO,
  ISubmissionDTO,
  ISubmissionRubricFormFieldDTO,
  SubmissionDTO,
  SubmissionRubricFormFieldDTO,
} from '.';

export interface ISubmissionRubricFormDTO extends IBaseEntityDTO {
  rubric: IRubricDTO | undefined;
  submission: ISubmissionDTO | undefined;
  fields: ISubmissionRubricFormFieldDTO[];
  submitted: boolean;
  submitted_date?: Date;
  isValid(): boolean;
}

export class SubmissionRubricFormDTO extends BaseEntityDTO implements ISubmissionRubricFormDTO {
  rubric: IRubricDTO | undefined;
  submission: ISubmissionDTO | undefined;
  fields: ISubmissionRubricFormFieldDTO[];
  submitted: boolean;
  submitted_date?: Date;

  constructor(data?: Partial<ISubmissionRubricFormDTO>) {
    super();
    this.rubric = new RubricDTO(data?.rubric);
    this.submission = new SubmissionDTO(data?.submission);
    this.fields = data?.fields
      ? data.fields.map((field) => new SubmissionRubricFormFieldDTO(field))
      : [];
    this.submitted = data?.submitted ? data.submitted : false;
    this.submitted_date = data?.submitted_date ? data.submitted_date : undefined;
  }

  isValid = (): boolean => {
    let valid = true;
    for (const field of this.fields) {
      if (field.isValid() == false) {
        valid = false;
        break;
      }
    }
    return valid;
  };
}
